import { Group } from '@mantine/core'
import React from 'react'

import TimeDisplayPicker from './TimeDisplayPicker'
import { useAdditionalServiceControlledTime } from './useAdditionalServiceControlledTime'

const V2Time = (props) => {
  const {
    mode,
    restrictions,
    isPickup,
    hideFromTime,
    hideUntilTime,
    allowDateChange,
    until,
    additionalService,
  } = props

  const startEditAllowed = mode === 'timespan' || mode === 'lefttimespan'
  const endEditAllowed = mode === 'timespan' || mode === 'righttimespan'

  // TODO: check through timeOptions to see if other edit options are available and which ones

  const showBoth = !hideFromTime && !hideUntilTime

  const isSlf = additionalService?.name === 'SLF'
  const isSpu = additionalService?.name === 'SPU'

  useAdditionalServiceControlledTime({
    mode,
    isPickup,
    until,
  })

  return (
    <div>
      <div>
        <div>
          {isPickup
            ? isSlf
              ? i18n.t('self_delivery', 'Anlieferung')
              : i18n.t('pickup_time', 'Abholzeit')
            : isSpu
            ? i18n.t('self_pickup', 'Abholung')
            : i18n.t('delivery_time', 'Zustellzeit')}
          :{' '}
        </div>
      </div>
      <Group noWrap spacing="xs" pt={5}>
        {!hideFromTime && (
          <TimeDisplayPicker
            name="from"
            isEditAllowed={startEditAllowed}
            allowDateChange={allowDateChange}
            until={until}
          />
        )}
        {showBoth && <div>-</div>}
        {!hideUntilTime && (
          <TimeDisplayPicker
            name="until"
            isEditAllowed={endEditAllowed}
            allowDateChange={allowDateChange}
            until={until}
          />
        )}
      </Group>
    </div>
  )
}

export default V2Time
